"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedCallback = exports.useDebounce = exports.debounce = void 0;
const debounce_1 = __importDefault(require("./debounce"));
exports.debounce = debounce_1.default;
const useDebounce_1 = __importDefault(require("./useDebounce"));
exports.useDebounce = useDebounce_1.default;
const useDebouncedCallback_1 = __importDefault(require("./useDebouncedCallback"));
exports.useDebouncedCallback = useDebouncedCallback_1.default;
// Default export for backward compatibility
exports.default = debounce_1.default;
